export const plans = [
    {
        planLabel: "PACKAGE_SMALL",
        description: "PACKAGE_SMALL_DESC",
        price: "1995",
        currency: "SEK ",
        billingCycle: "MONTH",
        features: [
            "FEATURE_200_VOUCHERS",
            "FEATURE_WAGES",
            "FEATURE_MONTHLY_REPORTS",
            "FEATURE_VAT_ACCOUNTING",
            "FEATURE_EMPLOYER_CONTRIBUTIONS",
            "FEATURE_ANNUAL_ACCOUNTS",
            "FEATURE_BILLING",
            "FEATURE_CURRENT_ACCOUNTING"
        ],
        buttonText: "CONTACT_US",
        backgroundColor: "#ffffff",
        buttonColor: "#6750B8"
    },
    {
        planLabel: "PACKAGE_MEDIUM",
        description: "PACKAGE_MEDIUM_DESC",
        price: "2995",
        currency: "SEK ",
        billingCycle: "MONTH",
        features: [
            "FEATURE_400_VOUCHERS",
            "FEATURE_WAGES",
            "FEATURE_MONTHLY_REPORTS",
            "FEATURE_VAT_ACCOUNTING",
            "FEATURE_EMPLOYER_CONTRIBUTIONS",
            "FEATURE_ANNUAL_ACCOUNTS",
            "FEATURE_BILLING",
            "FEATURE_CURRENT_ACCOUNTING"
        ],
        buttonText: "CONTACT_US",
        backgroundColor: "#ffffff",
        buttonColor: "#6750B8"
    },
    {
        planLabel: "CUSTOM",
        description: "PACKAGE_CUSTOM_DESC",
        price: "LETS_TALK",
        features: [
            "FEATURE_400_PLUS_VOUCHERS",
            "FEATURE_HOURLY_RATE",
            "FEATURE_WAGES",
            "FEATURE_MONTHLY_REPORTS",
            "FEATURE_VAT_ACCOUNTING",
            "FEATURE_EMPLOYER_CONTRIBUTIONS",
            "FEATURE_ANNUAL_ACCOUNTS",
            "FEATURE_BILLING",
            "FEATURE_CURRENT_ACCOUNTING"
        ],
        buttonText: "BOOK_A_CALL",
        backgroundColor: "#F4F3F9",
        buttonColor: "#2A214B"
    }
];